/**
 * Флаги облачка «первый раз» над строкой (ТЗ главной § 10). Все обращения к хранилищу — в try/catch:
 * без хранилища строка работает, облачко просто не показывается.
 */

const firstDoneKey = (userId: string) => `lx.composer.firstDone.${userId}`;

/** Ученик уже создавал карточки со строки (или хранилище недоступно — тогда облачка нет). */
export function readFirstDone(userId: string | undefined): boolean {
  if (!userId) return true;
  try {
    return window.localStorage.getItem(firstDoneKey(userId)) === '1';
  } catch {
    return true;
  }
}

export function markFirstDone(userId: string | undefined): void {
  if (!userId) return;
  try {
    window.localStorage.setItem(firstDoneKey(userId), '1');
  } catch {
    // хранилище недоступно — облачко покажется ещё раз, это не страшно
  }
}
